import React, { useState } from "react";
import { useNavigate } from "react-router";
import login_close from "../../assets/close_login.svg";
import eye from "../../assets/eye.svg";
import { useUser } from "../../providers/UserProvider";
import { setSessionData } from "services/session.service";
import { routes } from "routes/routes";

const LoginPopup = ({ onClose, onLoginSuccess }) => {
  const navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(false);
  const { updateUser, login } = useUser();
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    // Basic validation to check empty field for email and password
    if (!loginData.email && !loginData.password) {
      setError("Email and password are required.");
      return;
    } else if (!loginData.email) {
      setError("Email is required.");
      return;
    } else if (!loginData.password) {
      setError("Password is required.");
      return;
    }

    try {
      const { data } = await login({ ...loginData, rememberMe });

      updateUser(data.admin);
      setSessionData("email", data.admin.email);
      navigate(routes.home);
      setError("");
      onClose();
      onLoginSuccess();
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          setError("Invalid Email or password");
          console.error("Login failed");
        } else {
          setError(error.response.data?.message);
        }
      } else if (error.request) {
        setError(error?.message);
      } else {
        setError(error?.message);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
      <div className="bg-white pt-3 rounded-lg w-full relative max-w-[500px]">
        <div className="flex items-center justify-between border-b border-[#D9D9D9] pb-3 px-6">
          <h2 className="font-semibold">Login</h2>
          <button className="" onClick={onClose}>
            <img src={login_close} alt="" className="" />
          </button>
        </div>

        {error && error !== "" && (
          <p className="flex justify-between items-center bg-red-100 border-l-2 border-0 mb-5 border-red-400 text-red-700 px-4 py-3">
            {error}
            <span
              className="cursor-pointer"
              onClick={() => {
                setError("");
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 26 26"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1}
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </span>
          </p>
        )}

        <form className="space-y-4 mt-3" onSubmit={handleLoginSubmit}>
          <div className=" px-6 ">
            <label className="block text-[14px] font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={loginData.email}
              onChange={handleInputChange}
              placeholder="Enter email"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
            />
          </div>

          <div className="px-6">
            <label className="block text-[14px] font-medium text-gray-700 mb-1">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={loginData.password}
                onChange={handleInputChange}
                placeholder="**********"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "👁️" : <img src={eye} alt="hide password" />}
              </button>
            </div>
          </div>

          <div className="flex items-center justify-between px-6 pb-3">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={rememberMe}
                className="rounded w-[20px] h-[20px] border border-[#D9D9D9] mr-2"
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span className="text-[14px] leading-[16.94px] font-medium">
                Remember me
              </span>
            </label>
          </div>
          <div className=" py-3 px-6 border-t border-[#D9D9D9] w-full">
            <button
              type="submit"
              className="w-full bg-[#55C880] text-white font-medium py-2 px-4 rounded-md transition-colors duration-200"
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPopup;
